import type { RouteType, RouteContext } from "types/RouteType";
import type { RootStore } from "@intrasync/stores";
import type SalesTargetsStore from "./SalesTargetsStore";

/**
 * Where the bookings-vs-target comparison gets its target.
 *
 * A host screen rather than the auto-generated ServiceView: that generated
 * destination cannot load data (see SalesTargetsStore for the detail), and a
 * tile reading "no target set" has to lead somewhere the target can be set.
 */
const salesTargetsRoute: RouteType = {
  name: "Sales Targets",
  title: "Sales Targets",
  path: "/dashboards/sales-targets",
  layout: "/app",
  group: "Dashboards",
  requiresAuth: true,
  requiresPermission: false,
  enableAutoFind: false,
  viewportCard: {
    header: {
      title: "Sales Targets",
      enableRefreshButton: true,
      enableBackButton: true,
      component: () => import("./SalesTargets.Header"),
    },
    body: {
      component: () => import("./SalesTargets.Body"),
      grayBackground: true,
    },
  },
  onEnter: async ({ rootStore }: RouteContext) => {
    const store = (
      rootStore as RootStore & { salesTargetsViewStore?: SalesTargetsStore }
    ).salesTargetsViewStore;
    if (store) await store.loadData();
  },
};

export default salesTargetsRoute;
